import Entity from './entity'
export default class SmsSetting extends Entity<number>{
    name:string;
    isActive:boolean;
  
}